import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormHelperText, FormLabel } from '@mui/material';

const SIZE_CONFIG = {
	normal: {
		labelFontSize: 14,
		labelMarginBottom: 0.5,
	},
	small: {
		labelFontSize: 12,
		labelMarginBottom: 0.25,
	},
};

function FormFieldWrapper({
	label,
	size = 'normal',
	disabled = false,
	error = false,
	helperText,
	children,
}) {
	const cfg = SIZE_CONFIG[size] || SIZE_CONFIG.normal;

	return (
		<FormControl fullWidth disabled={disabled} error={error} sx={{ mb: 2 }}>
			{label && (
				<FormLabel
					sx={{
						mb: cfg.labelMarginBottom,
						fontSize: cfg.labelFontSize,
						color: 'text.secondary',
					}}
				>
					{label}
				</FormLabel>
			)}

			{children}

			{helperText && (
				<FormHelperText sx={{ mt: 0.5 }}>{helperText}</FormHelperText>
			)}
		</FormControl>
	);
}

FormFieldWrapper.propTypes = {
	label: PropTypes.any,
	size: PropTypes.oneOf(['normal', 'small']),
	disabled: PropTypes.bool,
	error: PropTypes.bool,
	helperText: PropTypes.any,
	children: PropTypes.node.isRequired,
};

export default React.memo(FormFieldWrapper);
